import { axiosGet, axiosPost } from '@/api/handlers';
import { useMutation, useQuery } from '@/api/hooks';
import { QueryStoreModel } from '../_models/query-store';

export const useCreateQueryStore = () => {
  return useMutation({
    mutationFn: async (values: any) => {
      const res = await axiosPost('/api/query-store/', values);
      return QueryStoreModel.parse(res);
    },
  });
};

export const useQueryStore = (
  id: string | undefined | null,
  enabled = true,
) => {
  return useQuery({
    queryKey: ['queryStore', id],
    queryFn: async () => {
      const res = await axiosGet(`/api/query-store/${id}/`);
      return QueryStoreModel.parse(res);
    },
    enabled: !!id && enabled,
  });
};
